module.exports = __webpack_public_path__ + "static/media/ibd_neck2.1245c744.png";